/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FastCrawlLoaderRendererQueryVariables = {};
export type FastCrawlLoaderRendererQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly experiments: ReadonlyArray<string | null> | null;
                        readonly flowStates: {
                            readonly edges: ReadonlyArray<{
                                readonly node: {
                                    readonly flowKey: string | null;
                                    readonly " $fragmentRefs": FragmentRefs<"FastCrawlLoader_flowState">;
                                } | null;
                            } | null> | null;
                        } | null;
                    } | null;
                } | null> | null;
            };
            readonly flowStates: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly " $fragmentRefs": FragmentRefs<"FastCrawlLoader_flowState">;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    };
};
export type FastCrawlLoaderRendererQuery = {
    readonly response: FastCrawlLoaderRendererQueryResponse;
    readonly variables: FastCrawlLoaderRendererQueryVariables;
};



/*
query FastCrawlLoaderRendererQuery {
  viewer {
    user {
      orgs(first: 1000000) {
        edges {
          node {
            id
            experiments
            flowStates(first: 1000000) {
              edges {
                node {
                  flowKey
                  ...FastCrawlLoader_flowState
                  id
                }
              }
            }
          }
        }
      }
      flowStates(first: 1000000) {
        edges {
          node {
            ...FastCrawlLoader_flowState
            id
          }
        }
      }
      id
    }
    id
  }
}

fragment FastCrawlLoader_flowState on FlowState {
  id
  flowKey
  current {
    state
    percentComplete
    errorMessage
    id
  }
  pending {
    state
    percentComplete
    errorMessage
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "experiments",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flowKey",
        "storageKey": null
    } as any, v4 = {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FastCrawlLoader_flowState"
    } as any, v5 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any,
        (v1 /*: any*/)
    ], v6 = {
        "alias": null,
        "args": null,
        "concreteType": "FlowStatus",
        "kind": "LinkedField",
        "name": "current",
        "plural": false,
        "selections": (v5 /*: any*/),
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "concreteType": "FlowStatus",
        "kind": "LinkedField",
        "name": "pending",
        "plural": false,
        "selections": (v5 /*: any*/),
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "FastCrawlLoaderRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v0 /*: any*/),
                                                            "concreteType": "FlowStateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "flowStates",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "FlowStateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "FlowState",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                (v4 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "flowStates(first:1000000)"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "FlowStateConnection",
                                    "kind": "LinkedField",
                                    "name": "flowStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FlowState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "flowStates(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "FastCrawlLoaderRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v0 /*: any*/),
                                                            "concreteType": "FlowStateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "flowStates",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "FlowStateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "FlowState",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                (v1 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                (v7 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "flowStates(first:1000000)"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "FlowStateConnection",
                                    "kind": "LinkedField",
                                    "name": "flowStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FlowState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v3 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v7 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "flowStates(first:1000000)"
                                },
                                (v1 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v1 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "ef454e33ba96d3a604d9ab8821a76046",
            "id": null,
            "metadata": {},
            "name": "FastCrawlLoaderRendererQuery",
            "operationKind": "query",
            "text": "query FastCrawlLoaderRendererQuery {\n  viewer {\n    user {\n      orgs(first: 1000000) {\n        edges {\n          node {\n            id\n            experiments\n            flowStates(first: 1000000) {\n              edges {\n                node {\n                  flowKey\n                  ...FastCrawlLoader_flowState\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n      flowStates(first: 1000000) {\n        edges {\n          node {\n            ...FastCrawlLoader_flowState\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment FastCrawlLoader_flowState on FlowState {\n  id\n  flowKey\n  current {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n  pending {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '6cd540b3420aa482b18d5502634ad4a0';
export default node;
